<div class="pension-modal">
  <div class="header">
    <h2>{{ data?.title }}</h2>
    <div class="icon-container">
      <ion-icon role="button" tabindex="0" class="i-close" aria-label="Cerrar"
       (click)="closeModal()"
       (keydown.enter)="closeModal()"></ion-icon>
    </div>
  </div>
  <div class="contenedor">
    <div class="contenedor-parrafo">
      <h3>{{ tituloPasos }}</h3>
      <div class="pregunta-parrafo">
        <h2>{{ currentStep.question }}</h2>
        <p [innerHTML]="currentStep.paragraph"></p>
      </div>
    </div>
    <div class="formulario-header">
      <div class="formulario-respuesta">
        <form [formGroup]="form">
          <ng-container *ngFor="let step of steps; let i = index">
            <ion-radio-group
              *ngIf="currentStepIndex === i"
              [formControlName]="step.controlName"
              class="radio-group-respuesta"
            >
              <ion-item
                lines="none"
                class="radio-item"
                (keydown)="selectOption($event, step.controlName, true)"
              >
                <ion-radio
                  [value]="true"
                  labelPlacement="end"
                  justify="start"
                  id="SI"
                  >Si</ion-radio
                >
              </ion-item>
              <ion-item
                lines="none"
                class="radio-item"
                (keydown)="selectOption($event, step.controlName, false)"
              >
                <ion-radio
                  [value]="false"
                  labelPlacement="end"
                  justify="start"
                  id="NO"
                  >No</ion-radio
                >
              </ion-item>
            </ion-radio-group>
          </ng-container>
        </form>
        <app-stepper-dots
          [steps]="steps.length"
          [currentStep]="currentStepIndex"
        ></app-stepper-dots>
      </div>
      <div class="button-container">
        <div class="button-arrow">
          <button
            type="button"
            class="icon-button"
            (click)="prevStep()"
            [disabled]="currentStepIndex === 0"
          >
            <ion-icon name="chevron-back-outline"></ion-icon>
          </button>
          <button
            type="button"
            class="icon-button"
            (click)="nextStep()"
            [disabled]="currentStepIndex === steps.length - 1"
          >
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </button>
        </div>
        <button
          class="btn-basic"
          [disabled]="isContinueButtonDisabled()"
          (click)="continue()"
        >
          Continuar
        </button>
      </div>
    </div>
  </div>
</div>
